<script setup lang="ts">
import type { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import { AppTable, AppTh, AppTr, AppTd } from '@shared/ui/tables'
import { BtnToggle } from '@shared/ui/buttons'

import { useSectionExtraRatesTable } from '../../model/extra-rates/section-extra-rates-table.hook'
import ExtraRatesRateSelect from './ExtraRatesRateSelect.vue'

defineOptions({
  name: 'SectionExtraRatesTable',
})

const props = withDefaults(defineProps<SectionExtraRatesTableProps>(), {
  show: false,
})

interface SectionExtraRatesTableProps {
  id: ShortDaysOfWeek
  show?: boolean
}

const {
  refSlots,
  rateOptions,
  disabledRateOption,
  setToggleSlot,
  setChangeRate,
  isSlotEnabled,
} = useSectionExtraRatesTable({
  id: computed(() => props.id),
})
</script>

<template>
  <div
    v-show="show"
    class="extra-rates-table"
  >
    <AppTable
      class="rounded-table"
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh>Time slot (UTC)</AppTh>
          <AppTh>Local Time</AppTh>
          <AppTh>Enable Extra Rates</AppTh>
          <AppTh>Completed Extra Rate</AppTh>
          <AppTh>No Show Extra Rate</AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="(timeSlot, index) in refSlots"
          :key="index"
        >
          <AppTd>{{ timeSlot.time }}</AppTd>
          <AppTd>{{ timeSlot.time_local }}</AppTd>
          <AppTd>
            <BtnToggle
              :checked="timeSlot.enable_extra_rates"
              @click="(value) => setToggleSlot(value, index)"
            />
          </AppTd>
          <AppTd>
            <ExtraRatesRateSelect
              :name="`complete-${index}`"
              :enabled="isSlotEnabled(index)"
              :value="timeSlot.rates.complete"
              :options="rateOptions"
              :disabled-options="disabledRateOption"
              @change="(option) => setChangeRate(option, index, 'complete')"
            />
          </AppTd>
          <AppTd>
            <ExtraRatesRateSelect
              :name="`no-show-${index}`"
              :enabled="isSlotEnabled(index)"
              :value="timeSlot.rates.no_show"
              :options="rateOptions"
              :disabled-options="disabledRateOption"
              @change="(option) => setChangeRate(option, index, 'no_show')"
            />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./SectionExtraRatesTable.scss" />
